export const messages = {
  zeroProductsPercentage: {
    id: 'admin/promotions.form.review.zero-products-percentage',
  },
  highProductsPercentage: {
    id: 'admin/promotions.form.review.high-products-percentage',
  },
}
